import { render } from "./SavedJobsView.vue?vue&type=template&id=bf2603f0&scoped=true"
import script from "./SavedJobsView.vue?vue&type=script&lang=js"
export * from "./SavedJobsView.vue?vue&type=script&lang=js"

import "./SavedJobsView.vue?vue&type=style&index=0&id=bf2603f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf2603f0"]])

export default __exports__